<div style="display: flex; height: 100%;">
  <div class="left-column">
    <button mat-mini-fab color="primary" class="add-job-button" (click)="createAutoRedactionJob()" matTooltip="Create new auto-redaction job">
      <mat-icon>add</mat-icon>
    </button>
    <div class="card-container">
      <div *ngFor="let autoRedactionJob of autoRedactionJobs">
        <div style="display: flex; flex-direction: row;">
          <div *ngIf="isSelected(autoRedactionJob)" style="padding-bottom: 21px">
            <div class="selected-item mat-elevation-z6"></div>
          </div>
          <mat-card appearance="outlined" class="card-list" (click)="isSelected(autoRedactionJob) ? $event.stopImmediatePropagation() : setAutoRedactionJob(autoRedactionJob)" [ngClass]="{'mat-elevation-z8': isSelected(autoRedactionJob)}" style="width: 100%; margin: 10px 10px 10px 20px;">
            <mat-card-title style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; font-size: 16px">
              <div *ngIf="editAutoRedactionJobId === autoRedactionJob.id;else job_title" style="width: 100%;">
                <mat-form-field style="flex: auto; width: 100%;">
                  <input matInput (blur)="saveAutoRedactionJobChanges(autoRedactionJob)" (keyup.enter)="saveAutoRedactionJobChanges(autoRedactionJob)" [(ngModel)]="autoRedactionJob.title" maxlength="100">
                </mat-form-field>
              </div>
              <ng-template #job_title>
                <div (click)="editAutoRedactionJobId = autoRedactionJob.id" style="width: 100%;">
                  {{ autoRedactionJob.title }}
                </div>
              </ng-template>
              <div>
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editAutoRedactionJobId = autoRedactionJob.id">Rename</button>
                  <div *ngIf="autoRedactionJob.runStatus === RunStatus.created; else post_run_menu">
                    <button mat-menu-item (click)="selectFilter()">Filter</button>
                  </div>
                  <ng-template #post_run_menu>
                    <button mat-menu-item (click)="cloneAutoRedaction(autoRedactionJob);">Clone</button>
                  </ng-template>
                  <button mat-menu-item [disabled]="autoRedactionJob.runStatus === RunStatus.running" (click)="deleteAutoRedactionJob(autoRedactionJob)">Delete</button>
                </mat-menu>
              </div>
            </mat-card-title>
            <mat-card-subtitle style="flex-direction: column">
              <div>{{ (autoRedactionJob.runStatus === RunStatus.completed || autoRedactionJob.runStatus === RunStatus.running ? autoRedactionJob.dateTimeRun : autoRedactionJob.dateTimeCreated) | date:'M/d/yyyy h:mm:ss a' }}</div>
              <div>{{ getCreatedByName(autoRedactionJob.createdById) }}</div>
            </mat-card-subtitle>
            <mat-card-content>
              <div style="place-content: center space-evenly; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; width: 100%">

                <div style="width: 50%">
                  <h3 *ngIf="autoRedactionJob.runStatus === RunStatus.created">Created</h3>
                  <h3 *ngIf="autoRedactionJob.runStatus === RunStatus.running">Processing</h3>
                  <h3 *ngIf="autoRedactionJob.runStatus === RunStatus.completed">Completed</h3>
                  <h3>{{ autoRedactionJob.autoRedactionRules ? autoRedactionJob.autoRedactionRules.length : 'No ' }} Rules</h3>
                </div>

                <div style="width: 50%" *ngIf="autoRedactionJob.runStatus === RunStatus.created">
                  <button mat-button [disabled]="autoRedactionJob.autoRedactionRules.length === 0 || isProcessing$()" color="primary"
                          (click)="runAutoRedactionJob(autoRedactionJob); $event.stopPropagation()">Run
                  </button>
                </div>

                <div style="width: 50%" *ngIf="autoRedactionJob.runStatus === RunStatus.running || autoRedactionJob.runStatus === RunStatus.completed">
                  <h3>{{ (autoRedactionJob.redactedDocCount ? autoRedactionJob.redactedDocCount : 0) }} Redacted Docs</h3>
                  <h3 *ngIf="autoRedactionJob.runStatus === RunStatus.running">{{ (autoRedactionJob.processingDocCount ? autoRedactionJob.processingDocCount : 0) }} Docs remaining</h3>
                  <h3 *ngIf="autoRedactionJob.runStatus === RunStatus.completed">{{ getTotalRedactionCount(autoRedactionJob.autoRedactionRules) }} Redactions</h3>
                </div>
              </div>
              <div>
                <div *ngIf="isSelected(autoRedactionJob)" (click)="selectFilter()" style="display: flex; flex-direction: column;">
                  <button mat-button *ngIf="!autoRedactionJob.filterId" [disabled]="autoRedactionJob.runStatus === RunStatus.completed || autoRedactionJob.runStatus === RunStatus.running " style="width:33%">Add Filter</button>
                  <div *ngIf="autoRedactionJob.filterId" class="filter-string">
                    <mat-label style="font-size:12px; font-weight: bold;">Filter</mat-label>
                    <div style="padding-left: 5px">
                      {{ filterString }}
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <div class="right-column">
    <div style="display: flex; flex-direction: column; margin: 20px; z-index: 1; width: 100%;">
      <mat-toolbar color="primary" class="toolbar-over-card" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; padding: 20px;">
        <div *ngIf="selectedAutoRedactionJob$() as selectedAutoRedactionJob; else noneSelected" style="place-content: stretch center; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex; gap: 10px;">
          <span>{{selectedAutoRedactionJob.title}}</span>
          <span>
            <button mat-icon-button (click)="browseJob()" [routerLink]="[]" *ngIf="selectedAutoRedactionJob.runStatus === RunStatus.completed">
              <div style="box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: stretch;"> <mat-icon matTooltip="Browse redacted documents">read_more</mat-icon> </div>
            </button>
          </span>
        </div>
        <ng-template #noneSelected>Select Job</ng-template>
        <div *ngIf="selectedAutoRedactionJob$()?.runStatus ===  RunStatus.completed">
          <button mat-icon-button (click)="isGraphView = !isGraphView" [matTooltip]="isGraphView ? 'View Data Results' : 'View Graph'">
            <mat-icon>{{ toggleIcon() }}</mat-icon>
          </button>
        </div>
        <div *ngIf="selectedAutoRedactionJob$() && selectedAutoRedactionJob$().runStatus ===  RunStatus.created">
          <button mat-icon-button (click)="detailsComponent.showAddRuleDialog(detailsComponent.generateNewRule())" matTooltip="Create new auto-redaction rule">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" style="height: 100%;">
        <mat-card-content style="height: 100%; margin-bottom: 0px;">
          <div *ngIf="autoRedactionJobs.length === 0;else show_select">
            Please create an auto-redaction job
          </div>
          <ng-template #show_select>
            <ng-container *ngIf="!selectedAutoRedactionJob$();else show_job_details">
              Please select an auto-redaction job
            </ng-container>
          </ng-template>
          <ng-template #show_job_details>
            <lex-auto-redaction-details [autoRedactionJob]="selectedAutoRedactionJob$()" [isGraphView]="isGraphView" [isProcessing$]="isProcessing$" style="height: 100%"></lex-auto-redaction-details>
          </ng-template>
        </mat-card-content>
        <mat-card-footer style="font-size: 10px;text-align: center;">
          Lexbe does not redact metadata. Users are responsible for ensuring sensitive metadata is properly addressed prior to production.
        </mat-card-footer>
      </mat-card>
    </div>
  </div>
</div>